import { ca } from '@cian/analytics';

export function trackBannerShow(): void {
  ca('eventSite', {
    action: 'show_sopr',
    category: 'ListingKP',
    label: 'suburban_bf',
    name: 'oldevent',
    useLastProducts: true,
  });
}

export function trackBannerClick(): void {
  ca('eventSite', {
    action: 'Click',
    category: 'ListingKP',
    label: 'suburban_bf',
    name: 'oldevent',
    useLastProducts: true,
  });
}
